angular.module("confermaAccettazione.components", [])
    .component("confermaAccettazione", {
        templateUrl: "ng/components/riscattoAnticipato/confermaAccettazione/confermaAccettazione.view.html",
        bindings: {
            validateComponent: '&',
            model: '='
        },
        controller: ConfermaAccettazioneController,
        controllerAs: "confermaAccettazioneCtrl"
    })


function ConfermaAccettazioneController() {

    var self = this;

    self.$onInit = function () {
        self.supportModel = {
            readDocumentation: null
        }

        checkComponent();
    }

    var checkComponent = function () {

        if (self.supportModel.readDocumentation) {
            self.validateComponent({ value: true })
        } else {
            if (!!self.model.finalMex && self.supportModel.readDocumentation == false) {
                self.validateComponent({ value: true })
            } else {
                self.validateComponent({ value: false })
            }
        }

    }

    self.handleChange = function () {
        checkComponent();

    }
}